import styled from 'styled-components';
import type { DefaultTheme } from 'styled-components';

const toCss = (value: number | string) => (typeof value === 'number' ? `${value}px` : value);

type BaseSeparatorProps = {
  strokeWidth?: number;
  marginLeft?: number;
  marginRight?: number;
  marginTop?: number;
  marginBottom?: number;
  color?: string;
};

const baseStyles = ({
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  marginBottom = 0,
  color,
  theme,
}: Omit<BaseSeparatorProps, 'strokeWidth'> & { theme: DefaultTheme }) => `
  background-color: ${color ?? theme.kallisto.color.common.black[100]};
  margin-left: ${marginLeft}px;
  margin-right: ${marginRight}px;
  margin-top: ${marginTop}px;
  margin-bottom: ${marginBottom}px;
  flex-shrink: 0;
`;

// ─── Vertical Separator ───────────────────────────────────────────────────────

export type VerticalSeparatorProps = BaseSeparatorProps & {
  height?: number | string;
};

export const VerticalSeparator = styled.div<VerticalSeparatorProps>`
  width: ${({ strokeWidth = 1 }) => strokeWidth}px;
  height: ${({ height = '100%' }) => toCss(height)};
  ${(props) => baseStyles(props)}
`;

// ─── Spacer ───────────────────────────────────────────────────────────────────

export const Spacer = styled.div`
  @media (min-width: 768px) {
    flex-grow: 1;
    min-width: 0;
  }
`;
